class Menu {
  static MENU_ITEM_CLASS = 'menu-item';
  static MENU_SECTION_CLASS = 'menu-section';

  static GENDERS = {
    MEN: 'men',
    WOMEN: 'women'
  };

  constructor(element, options = {}) {
    const settings = {
      menuClassName: 'menu',
      activeGender: Menu.GENDERS.WOMEN,
      ...options
    };
    this.$element = element;

    this.init(settings);
  }

  init(options) {
    this.$activeAliases = [];
    this.$submenuVisibleLevel = -1;
    this.$menuClassName = options.menuClassName;

    this.initElements();
    this.addEventListeners();

    this.activeGender = options.activeGender;
  }

  initElements() {
    this.$frame = this.$element.querySelector(`.${this.$menuClassName}__frame`);
    this.$items = this.$element.querySelectorAll(`.${Menu.MENU_ITEM_CLASS}`);
    this.$submenus = this.$element.querySelectorAll(`.${this.$menuClassName}__level--submenu`);
    this.$submenuSections = this.$element.querySelectorAll(`.${Menu.MENU_SECTION_CLASS}--submenu`);
    this.$genderSections = this.$element.querySelectorAll(`.${Menu.MENU_SECTION_CLASS}--gender`);
    this.$genderSelectors = this.$element.querySelectorAll('.menu-genders__item');
  }

  addEventListeners() {
    this.$genderSelectors.forEach(selector => {
      selector.addEventListener('click', () => {
        this.selectGender(selector.dataset.gender);
      })
    });
  }

  /**
   *
   * @param level {null|number}
   */
  showSubmenu(level = null) {
    if (level === null) {
      level = this.submenuVisibleLevel + 1;
    }

    this.submenuVisibleLevel = level;
  }

  hideSubmenu() {
    this.submenuVisibleLevel = -1;
  }

  setActiveAlias(index, value) {
    const newActiveAliases = [...this.activeAliases];

    newActiveAliases[index] = value;

    this.activeAliases = [...newActiveAliases];
  }

  updateSections() {
    this.$submenuSections.forEach(section => {
      const sectionAlias = section.dataset.alias;

      section.classList.toggle(`${Menu.MENU_SECTION_CLASS}--active`, this.activeAliases.includes(sectionAlias));
    });

    this.$genderSections.forEach(section => {
      const sectionAlias = section.dataset.alias;

      section.classList.toggle(`${Menu.MENU_SECTION_CLASS}--active`, this.activeGender === sectionAlias);
    });

    this.$genderSelectors.forEach(selector => {
      const gender = selector.dataset.gender;

      selector.classList.toggle(`menu-genders__item--active`, this.activeGender === gender);
    });
  }

  /**
   *
   * @param gender {string}
   */
  selectGender(gender) {
    this.activeGender = gender;
  }

  /**
   *
   * @param value {string[]}
   */
  set activeAliases(value) {
    this.$activeAliases = value;

    this.updateSections();
  }

  get activeAliases() {
    return this.$activeAliases;
  }

  /**
   *
   * @param value {string}
   */
  set activeGender(value) {
    if (
      this.$activeGender === value ||
      !Object.values(Menu.GENDERS).includes(value)
    ) {
      return;
    }

    this.$activeGender = value;
    this.updateSections();
  }

  /**
   *
   * @return {string}
   */
  get activeGender() {
    return this.$activeGender;
  }

  /**
   *
   * @param value {number}
   */
  set submenuVisibleLevel(value) {
    if (this.$submenuVisibleLevel === value) {
      return;
    }

    this.$submenuVisibleLevel = value;
    this.$element.classList.toggle(`${this.$menuClassName}--submenu-visible`, this.$submenuVisibleLevel > -1);

    this.updateSections();
  }

  /**
   *
   * @return {number}
   */
  get submenuVisibleLevel() {
    return this.$submenuVisibleLevel;
  }

}